module.exports = __webpack_public_path__ + "static/media/brectanova10.04ef6e4d.jpg";